import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { css, jsx } from '@emotion/react';
import { useCallback } from 'react';
import { memoWithAs, forwardRefWithAs, useCss } from '@stacks/ui-core';

var Box = /*#__PURE__*/memoWithAs( /*#__PURE__*/forwardRefWithAs(function (_ref, ref) {
  var _ref$as = _ref.as,
      Element = _ref$as === void 0 ? "div" : _ref$as,
      props = _objectWithoutPropertiesLoose(_ref, ["as"]);

  var _useCss = useCss(props),
      styles = _useCss[0],
      _props = _useCss[1];

  var generateCss = useCallback(function (theme) {
    return css(styles(theme));
  }, [styles]);
  return /* @__PURE__ */jsx(Element, _extends({
    ref: ref,
    css: generateCss
  }, _props, {
    as: void 0
  }));
}));

export { Box };
//# sourceMappingURL=index.esm.js.map
